import { Capacitor, CapacitorHttp } from '@capacitor/core'
import { openUrl } from 'Utility/globalMethods'
import { isChatbotGatewayRequest } from './observeChatbotGatewayActivity'

// Determino l’ambiente da variabile di build (fallback a DEVELOP)
const ENV = process.env.DEPLOY_ENV_NAME || process.env.ENVIRONMENT || 'DEVELOP'

// Mappa environment → URL completo dello script
const SCRIPT_URLS = {
  DEVELOP: 'https://wwwstg.nexi.it/content/dam/nexi/business/scripts/chatbot.js',
  INTEGRATION: 'https://wwwstg.nexi.it/content/dam/nexi/business/scripts/chatbot.js',
  STAGING: 'https://wwwstg.nexi.it/content/dam/nexi/business/scripts/chatbot.js',
  PRODUCTION: 'https://www.nexi.it/content/dam/nexi/business/scripts/chatbot.js'
}

// Se ENV non è uno dei key previsti, uso DEVELOP
const scriptUrl = SCRIPT_URLS[ENV] || SCRIPT_URLS.DEVELOP

/**
 * Restituisce l’URL completo dello script chatbot
 * e imposta portalToken + logged in sessionStorage.
 */
export function getChatbotScriptBasedOnENV (onGatewayActivity = () => {}) {
  window.sessionStorage.setItem('portalToken', window.sessionStorage.getItem('jwe') || '')
  window.sessionStorage.setItem('logged', 'true')
  window.chatbotMobileRequestCallback = (requestData) => {
    const request = { ...requestData.request }
    let urlWithParams = `${request.url}`
    if (request.params && Object.keys(request.params).length !== 0) {
      const keys = Object.keys(request.params)
      const newUrl = urlWithParams.includes('?') ? `${urlWithParams}&` : `${urlWithParams}?`
      const params = new URLSearchParams()
      for (let i = 0; i < keys.length; i++) {
        params.append(keys[i], request.params[keys[i]])
      }
      urlWithParams = `${newUrl}${params.toString()}`
    }
    // set auth headers
    if (window.sessionStorage.getItem('jwe')) {
      request.headers.Authorization = `Bearer ${window.sessionStorage.getItem('jwe')}`
    }
    if (Capacitor.isNativePlatform() && window.sessionStorage.getItem('x-client-session')) {
      const sessionHeader = 'X-Client-Session'
      request.headers[sessionHeader] = window.sessionStorage.getItem('x-client-session')
    }
    return new Promise((resolve, reject) => {
      const requestObj = {
        method: request.method.toUpperCase(),
        url: urlWithParams,
        headers: request.headers,
        responseType: request.responseType,
        credentials: true
      }
      if (request.method.toUpperCase() === 'PUT' || request.method.toUpperCase() === 'POST') {
        requestObj.data = request.data
      }
      const requestPromise = CapacitorHttp.request(requestObj)
      if (isChatbotGatewayRequest(requestObj.url)) {
        try {
          onGatewayActivity()
        } catch {
          // Session tracking must not affect the external chatbot request.
        }
      }
      requestPromise
        .then(response => {
          const newResponse = {
            data: response.data,
            status: response.status,
            statusText: response.statusText ?? '',
            headers: response.headers,
            config: request,
            request
          }
          // interceptResponseAndSetJwe(newResponse)
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            ...newResponse,
            isAxiosError: false
          })
        })
        .catch(err => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({
            isAxiosError: true,
            response: {
              data: err?.error ?? null,
              status: err?.status ?? 500,
              statusText: err?.message ?? 'CapacitorHttp Error',
              headers: err?.headers ?? {},
              config: request
            }
          })
        })
    })
  }
  return scriptUrl
}

/**
 * Apri un URL esterno:
 * - su mobile Native via openUrl(url, false)
 * - su web con window.open(url, '_blank')
 */
export function openExternalUrl (url) {
  if (Capacitor.isNativePlatform()) {
    // su native usa openUrl che sfrutta InAppBrowser
    openUrl(url, false)
  } else {
    // su web sempre nuova tab
    window.open(url, '_blank')
  }
}

/**
 * Esportiamo anche scriptUrl grezzo se serve leggerlo altrove.
 */
export const appConfig = { scriptUrl }
